import React, { memo, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // Add this import

import { Button } from "../Components";
import Icon from "../../assets/icons/Icon";
import { logoutUser, sessionDetails } from "../../store/user/user-action";
import { uiActions } from "../../store/ui/ui-slice";
import { CommonModal } from "../Components/Modal";
import { Link } from "react-router-dom";
import logo from "/assets/images/logo.png";
import ChangePassword from "../../features/User/ChangePassword";
import ActiveSessions from "../../features/User/ActiveSessions";

const MODAL_STACK = {
  changePassword: ChangePassword,
  activeSessions: ActiveSessions,
};

const Topbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Add this
  const user = useSelector((state) => state.user?.user);
  const theme = useSelector((state) => state.ui?.theme);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
  });

  // Add these missing variables
  const userDetails = user || {};
  const userImg = userDetails?.ProfileImage || "/assets/images/userIcon.svg";

  useEffect(() => {
    if (theme) {
      const root = document.documentElement;
      root.setAttribute("data-bs-theme", theme);
    }
  }, [theme]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleTheme = () => {
    const root = document.documentElement;
    const currentTheme = root.getAttribute("data-bs-theme");

    if (currentTheme === "dark") {
      dispatch(uiActions.setTheme("light"));
    } else {
      dispatch(uiActions.setTheme("dark"));
    }
  };

  const handleSideCollapsed = () => {
    const body = document.querySelector("body");
    const currentSize = body.getAttribute("data-sidebar-size");
    if (currentSize && currentSize !== "default") {
      body.setAttribute("data-sidebar-size", "default");
    } else {
      body.setAttribute("data-sidebar-size", "collapsed");
    }
  };

  const handleLogout = async () => {
    await logoutUser(dispatch);
  };

  // Add missing function
  const handleMenuClick = (path) => {
    setIsUserMenuOpen(false);

    if (path === "/change-password") {
      setIsShow((prev) => ({
        ...prev,
        isOpen: true,
        modalTitle: "Change Password",
        name: "change-password",
      }));
      return;
    }

    navigate(path);
  };

  // Add missing function
  const handleConfirmLogout = () => {
    // You can add a confirmation modal here if needed
    if (window.confirm("Are you sure you want to logout?")) {
      handleLogout();
    }
  };

  // Add missing utility function
  const getRemainingDays = (endDate) => {
    if (!endDate) return "N/A";
    const today = new Date();
    const end = new Date(endDate);
    const diffTime = end - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return "Expired";
    if (diffDays === 0) return "Expires today";
    if (diffDays === 1) return "Expires tomorrow";
    return `${diffDays} days remaining`;
  };

  // Add missing utility function
  const dateTimeFormat = ({ dateStr }) => {
    if (!dateStr) return { date: "N/A", time: "" };
    const dateObj = new Date(dateStr);
    const date = dateObj.toLocaleDateString();
    const time = dateObj.toLocaleTimeString();
    return { date, time };
  };

  const handleRefresh = () => {
    sessionDetails(dispatch);
    navigate("/");
  };

  return (
    <>
      <header className="headerTop">
        <Link to="/" className="logo_box">
          <img alt="Logo" src={logo} className="logo_img" />
        </Link>
        <div className="user_dropdbShow">
          <Button
            className="ico-search"
            icon="RefreshCcw"
            onClick={handleRefresh}
          />
          {/* <Button className="ico-search" icon="Search" /> */}
          <button
            className="theme_btn desktop_only"
            title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
            onClick={handleTheme}
            aria-label="Toggle theme"
          >
            {theme === "dark" ? (
              <Icon name="Sun" className="dark-mode" />
            ) : (
              <Icon name="Moon" className="light-mode" />
            )}
          </button>
          <div className="user_dropdown_wrapper " ref={userMenuRef}>
            <button
              type="button"
              className={`btn_user ${isUserMenuOpen ? "active" : ""}`}
              onClick={() => setIsUserMenuOpen((prev) => !prev)}
              aria-expanded={isUserMenuOpen}
              aria-haspopup="menu"
            >
              <img src={userImg} alt="user" />
              <span>
                {user?.name || "User"}
                <Icon name="chevronDownIcon" />
              </span>
            </button>

            <div className={`menu_dropdbShow ${isUserMenuOpen ? "show" : ""}`}>
              <div className="menu-item theme_box mobile_only">
                <span>Theme</span>
                <button
                  className="theme_btn"
                  title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
                  onClick={handleTheme}
                  aria-label="Toggle theme"
                >
                  {theme === "dark" ? (
                    <Icon name="Moon" className="dark-mode" />
                  ) : (
                    <Icon name="Sun" className="light-mode" />
                  )}
                </button>
              </div>
              <div className="separator mobile_only"></div>

              <div className="menu-item">
                <button
                  className="menu-link"
                  role="menuitem"
                  onClick={() => handleMenuClick("/two-factor-auth")}
                >
                  <Icon name="ShieldPlus" />
                  &nbsp; Two Factor Auth
                </button>
              </div>
              <div className="menu-item">
                <button
                  className="menu-link"
                  role="menuitem"
                  onClick={() => {
                    setIsUserMenuOpen(false);
                    setIsShow((prev) => ({
                      ...prev,
                      isOpen: true,
                      modalTitle: "Change Password",
                      name: "change-password",
                      modalContent: MODAL_STACK.changePassword,
                    }));
                  }}
                >
                  <Icon name="RotateCcwKey" />
                  &nbsp; Change Password
                </button>
              </div>
              <div className="menu-item">
                <button
                  className="menu-link"
                  role="menuitem"
                  onClick={() => {
                    setIsUserMenuOpen(false);
                    setIsShow((prev) => ({
                      ...prev,
                      isOpen: true,
                      modalTitle: "Active Sessions",
                      name: "activeSessions",
                      modalContent: MODAL_STACK.activeSessions,
                    }));
                  }}
                >
                  <Icon name="KeyRound" />
                  &nbsp; Active Sessions
                </button>
              </div>
              <div className="separator" role="separator"></div>
              <div className="menu-item">
                <button
                  type="button"
                  className="menu-link"
                  role="menuitem"
                  onClick={() => {
                    setIsUserMenuOpen(false);
                    setIsShow((prev) => ({
                      ...prev,
                      isOpen: true,
                      modalTitle: "Logout",
                      name: "logout",
                    }));
                  }}
                >
                  <Icon name="LogOut" />
                  &nbsp; Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              name: "",
              modalTitle: "",
            }))
          }
          modalTitle={isShow.modalTitle}
          size={isShow.name !== "logout" ? "md" : "sm"}
          isFooter={false}
        >
          {isShow.name !== "logout" && isShow.modalContent ? (
            React.createElement(isShow.modalContent, {
              handleModalHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                  apiFlag: !prev.apiFlag,
                })),
            })
          ) : (
            <div className="confirmation-model">
              <div className="confirmation-model__badge" aria-hidden="true">
                !
              </div>
              <p className="confirmation-model__eyebrow ">
                Please confirm this action
              </p>
              <h5 className="confirmation-model__title ">
                Are you sure you want to log out?
              </h5>

              <div className="confirmation-model__button">
                <Button
                  className="btn btn_main btn_muted"
                  onClick={() =>
                    setIsShow((prev) => ({
                      ...prev,
                      isOpen: false,
                      name: "",
                      modalTitle: "",
                    }))
                  }
                >
                  No
                </Button>

                <Button
                  className="btn btn_main"
                  onClick={async () => {
                    await handleLogout();

                    setIsShow((prev) => ({
                      ...prev,
                      isOpen: false,
                      name: "",
                      modalTitle: "",
                    }));
                  }}
                  autoFocus={true}
                >
                  Yes
                </Button>
              </div>
            </div>
          )}

          {/* {isShow.name === "change-password" ? (
            <ChangePassword
              handleShowHide={() =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  name: "",
                  modalTitle: "",
                }))
              }
            />
          ) :} */}
        </CommonModal>
      )}
    </>
  );
};

export default memo(Topbar);
